import { render, staticRenderFns } from "./ContactToggle.vue?vue&type=template&id=49c56baa&"
import script from "./ContactToggle.vue?vue&type=script&lang=js&"
export * from "./ContactToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports